export default __webpack_public_path__ + "static/media/sun.e8160910.png";